<a routerLink="/" class="logo" [attr.data-testid]="'logoLink'" (click)="logoClicked.emit()">
  <img class="logo__image" [ngSrc]="logoSrc" alt="logo" priority="true" fill="true" />
</a>
